import api from "./api.js";

export default class OnboardingApi {
  static async register(data) {
    return await api.post(`api/onboarding`, data);
  }

  static async getList(data) {
    return await api.get(`api/onboarding`, data);
  }
}
